import USER_ROLE from 'constants/role';

const N = Object.freeze({
  id: -1,
  userRole: USER_ROLE.noAccess,
  found: -1,
  defined: void 1,
  date: new Date(NaN),
});

// to make it closer to normal English: NO.id, NOT.found
export { N as NOT };
export { N as NO };
